import { render } from "./CVBuilderView.vue?vue&type=template&id=7dacc671&scoped=true"
import script from "./CVBuilderView.vue?vue&type=script&lang=js"
export * from "./CVBuilderView.vue?vue&type=script&lang=js"

import "./CVBuilderView.vue?vue&type=style&index=0&id=7dacc671&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dacc671"]])

export default __exports__